import React from "react";
import Text from "../Text/Text";

interface Option {
  value: string | number;
  label: string;
}

interface SelectProps {
  label?: string;
  options: Option[];
  name?: string;
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  required?: boolean;
}

const Select: React.FC<SelectProps> = ({
  label,
  options,
  name,
  value,
  onChange,
  disabled = false,
  required = false,
}) => {
  return (
    <React.Fragment>
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
        </label>
      )}
      <select
        id={name}
        name={name}
        className="form-select"
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
      >
        <option value="" disabled>
          <Text size="md">Select an option</Text>
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            <Text size="md">{option.label}</Text>
          </option>
        ))}
      </select>
    </React.Fragment>
  );
};

export default Select;
